import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Typography, Divider, MenuItem, Grid, InputLabel, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, DialogContentText } from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import tokenDecoder from '../../../utils/tokenDecoder';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Delete from '@material-ui/icons/Delete';
import PageHeader from 'src/views/Common/PageHeader';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    table: {
        minWidth: 550,
    },
}));

const screenCode = "GREENLEAFRECEIVING"
export default function GreenLeafReceivingADDEDIT() {
    const classes = useStyles();
    const navigate = useNavigate();
    const alert = useAlert();
    const { greenLeafReceivingDetailsID } = useParams();
    const [isUpdate, setIsUpdate] = useState(false);
    const [title, setTitle] = useState("Add Green Leaf Receiving");
    const [groups, setGroups] = useState();
    const [divisions, setDivisions] = useState();
    const [factory, setFactory] = useState([]);
    const [estates, setEstates] = useState([]);
    const [estatesList, setEstatesList] = useState([]);
    const [fields, setFields] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [leafTypes, setLeafTypes] = useState([]);
    const [collectedDate, setCollectedDate] = useState(new Date());
    const [isDropdownDisabled, setIsDropdownDisabled] = useState(false);
    const [mappingArray, setMappingArray] = useState([]);
    const [rowdata, setRowdata] = useState();
    const [executionConfirmationOpen, setExecutionConfirmationOpen] = useState(false);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);
    const [GreenLeafReceivingDetails, setGreenLeafReceivingDetails] = useState({
        groupID: 0,
        leafTypeID: 0,
        estateID: 0,
        factoryID: 0,
        leafWeight: 0,
        supplierID: 0,
        routeID: 0,
    });
    const [backConfirmation, setBackConfirmation] = React.useState(false);
    const [firstQuantity, setfirstQuantity] = useState(0);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isRegionFilterEnabled: false
    });

    const handleClick = () => {
        if (mappingArray.length > 0) {
            setBackConfirmation(true);
        } else {
            navigate('/app/GreenLeafReceiving/listing');
        }
    };

    let decrypted = 0;
    useEffect(() => {
        decrypted = atob(greenLeafReceivingDetailsID.toString());
        if (decrypted != 0) {
            trackPromise(
                greenLeafReceivingDetailsBYID(decrypted)
            )
        }
    }, []);

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermissions(), GetAllLeafType());
    }, []);

    useEffect(() => {
        if (GreenLeafReceivingDetails.groupID > 0) {
            getEsatesForDropdown(GreenLeafReceivingDetails.groupID);
        }
    }, [GreenLeafReceivingDetails.groupID]);

    useEffect(() => {
        if (
            GreenLeafReceivingDetails.groupID > 0) {
            getEstateDetailsByGroupID(GreenLeafReceivingDetails.groupID);
        }
    }, [GreenLeafReceivingDetails.groupID, GreenLeafReceivingDetails.leafTypeID]);

    useEffect(() => {
        if (GreenLeafReceivingDetails.groupID > 0) {
            getFactoryDetailsByGroupID(GreenLeafReceivingDetails.groupID);
        }
    }, [GreenLeafReceivingDetails.groupID, GreenLeafReceivingDetails.leafTypeID]);

    useEffect(() => {
        if (GreenLeafReceivingDetails.estateID > 0) {
            GetRouteByFactoryID(GreenLeafReceivingDetails.estateID);
        }
    }, [GreenLeafReceivingDetails.estateID]);

    useEffect(() => {
        if (GreenLeafReceivingDetails.routeID > 0) {
            GetSuppliersByRouteID(GreenLeafReceivingDetails.routeID);
        }
    }, [GreenLeafReceivingDetails.routeID]);

    useEffect(() => {
        if (mappingArray.length == 0) {
            setIsDropdownDisabled(false);
        }
        setGreenLeafReceivingDetails({
            ...GreenLeafReceivingDetails,
            leafWeight: 0,
        })
    }, [mappingArray]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITGREENLEAFRECEIVING');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
        var isRegionFilterEnabled = permissions.find(p => p.permissionCode == 'REGIONDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            isRegionFilterEnabled: isRegionFilterEnabled !== undefined,
        });

        setGreenLeafReceivingDetails({
            ...GreenLeafReceivingDetails,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            estateID: parseInt(tokenService.getFactoryIDFromToken())
        })
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getEsatesForDropdown(groupID) {
        const factories = await services.getEstateByGroupID(groupID);
        setEstatesList(factories);
    }

    async function getEstateDetailsByGroupID(groupID) {
        let operationEntityTypeID = 1
        const response = await services.getEstateDetailsByGroupID(groupID, operationEntityTypeID);
        setEstates(response);
    }

    async function getFactoryDetailsByGroupID(groupID) {
        let operationEntityTypeID = 2
        const response = await services.getFactoryDetailsByGroupID(groupID, operationEntityTypeID);
        setFactory(response);
    }

    async function GetRouteByFactoryID(factoryID) {
        const response = await services.GetRouteByFactoryID(factoryID);
        setRoutes(response);
    }

    async function GetSuppliersByRouteID(routeID) {
        const response = await services.GetSuppliersByRouteID(routeID);
        setSuppliers(response);
    }

    async function GetAllLeafType() {
        const response = await services.GetAllLeafType();
        setLeafTypes(response);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            const entries = Object.entries(data);
            entries.sort((a, b) => a[1].localeCompare(b[1]));
            for (const [key, value] of entries) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function handleGoBackWithoutSaving() {
    }

    function handleSaveAndGoBack() {
        SaveGreenLeafReceivingData();
    }

    function clearData() {
        setGreenLeafReceivingDetails({
            ...GreenLeafReceivingDetails,
            groupID: tokenDecoder.getGroupIDFromToken(),
            leafTypeID: 0,
            estateID: 0,
            factoryID: 0,
            leafWeight: 0,
            supplierID: 0,
            routeID: 0,
        });
        setCollectedDate(new Date());
        setMappingArray([]);
        if (isUpdate) {
            setIsUpdate(false);
            setTitle("Add Green Leaf Receiving");
        }
    }

    function handleChangeWeight(e) {
        const target = e.target;
        const value = target.value
        setGreenLeafReceivingDetails({
            ...GreenLeafReceivingDetails,
            [e.target.name]: value
        });
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        if (name === "groupID") {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                [name]: value,
                leafTypeID: 0,
                estateID: 0,
                factoryID: 0,
                leafWeight: 0,
                supplierID: 0,
                routeID: 0,
            });
        }
        else if (name === "estateID") {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                [name]: value,
                leafTypeID: 0,
                factoryID: 0,
                leafWeight: 0,
                supplierID: 0,
                routeID: 0,
            });

        }
        else if (name === "leafTypeID") {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                [name]: value,
                leafWeight: 0,
                supplierID: 0,
                routeID: 0,
            });
        }
        else if (name === "routeID") {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                [name]: value,
                supplierID: 0,
            });

        }
        else {
            setGreenLeafReceivingDetails({
                ...GreenLeafReceivingDetails,
                [name]: value
            });
        }
    }

    async function greenLeafReceivingDetailsBYID(greenLeafReceivingDetailsID) {
        let response = await services.greenLeafReceivingDetailsBYID(greenLeafReceivingDetailsID);
        let data = response[0];
        setTitle("Edit Green Leaf Receiving");
        setGreenLeafReceivingDetails(data);
        setfirstQuantity(data.leafWeight)
        setCollectedDate(data.collectedDate);
        setIsUpdate(true);
    }

    async function AddData() {
        if (isUpdate == true) {
            const updateModel = {
                greenLeafReceivingDetailsID: GreenLeafReceivingDetails.greenLeafReceivingDetailsID,
                groupID: parseInt(GreenLeafReceivingDetails.groupID),
                estateID: parseInt(GreenLeafReceivingDetails.factoryID),
                collectedDate: collectedDate,
                leafWeight: GreenLeafReceivingDetails.leafWeight,
                leafTypeID: GreenLeafReceivingDetails.leafTypeID,
                firstQuantity: parseFloat(firstQuantity),
                modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
            };

            var response = await services.UpdateGreenLeafReceivingData(updateModel);
            if (response.statusCode == "Success") {
                alert.success(response.message);
                setIsUpdate(false)
                navigate('/app/GreenLeafReceiving/listing');
            }
            else {
                alert.error(response.message);
            }
        }
        else {
            const newMappings = [];
            const baseModel = {
                groupID: parseInt(GreenLeafReceivingDetails.groupID),
                leafTypeID: parseInt(GreenLeafReceivingDetails.leafTypeID),
                estateID: parseInt(GreenLeafReceivingDetails.estateID),
                factoryID: parseInt(GreenLeafReceivingDetails.factoryID),
                leafWeight: GreenLeafReceivingDetails.leafWeight,
                collectedDate: collectedDate,
                supplierID: parseInt(GreenLeafReceivingDetails.supplierID),
                routeID: parseInt(GreenLeafReceivingDetails.routeID),
            };

            var response = await services.GetExestingGreenLeafReceivingDeta(baseModel);
            if (response.statusCode == "Error") {
                alert.error(response.message);
                return;
            } else {
                newMappings.push({
                    ...baseModel,
                    groupName: parseInt(GreenLeafReceivingDetails.groupID) > 0 ? groups[GreenLeafReceivingDetails.groupID] : '',
                    leafTypeName: parseInt(GreenLeafReceivingDetails.leafTypeID) > 0 ? leafTypes[GreenLeafReceivingDetails.leafTypeID] : '',
                    estateName: parseInt(GreenLeafReceivingDetails.estateID) > 0 ? estatesList[GreenLeafReceivingDetails.estateID] : '',
                    factoryName: parseInt(GreenLeafReceivingDetails.factoryID) > 0 ? factory[GreenLeafReceivingDetails.factoryID] : '',
                    supplierName: parseInt(GreenLeafReceivingDetails.supplierID) > 0 ? suppliers[GreenLeafReceivingDetails.supplierID] : '',
                    routeName: parseInt(GreenLeafReceivingDetails.routeID) > 0 ? routes[GreenLeafReceivingDetails.routeID] : '',
                    isActive: true,
                    createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
                    createdDate: new Date().toISOString()
                });

                setIsDropdownDisabled(true);
            }
            if (newMappings.length > 0) {
                const filteredMappings = newMappings.filter(newMapping => (
                    !mappingArray.some(existingMapping => (
                        existingMapping.leafWeight === newMapping.leafWeight &&
                        existingMapping.collectedDate === newMapping.collectedDate
                    ))
                ));
                if (filteredMappings.length < newMappings.length) {
                    alert.error('Cannot add duplicate records');
                }
                if (filteredMappings.length > 0) {
                    setMappingArray(prev => [...prev, ...filteredMappings]);
                }
            }
        }
    }

    const DeleteDetails = (row) => {
        const updatedArray = mappingArray.filter(item => item !== row);
        setMappingArray(updatedArray);
        setDeleteConfirmationOpen(false);
    };

    async function SaveGreenLeafReceivingData() {
        setSaveButtonDisabled(true);
        setIsDropdownDisabled(false);
        setExecutionConfirmationOpen(false);
        if (mappingArray.length > 0) {
            var response = await services.SaveGreenLeafReceivingData(mappingArray);
            if (response.statusCode == "Success") {
                alert.success(response.message);
                clearData();
                setMappingArray([]);
            }
            else {
                alert.error(response.message);
            }
        }
    }

    const handleCancleExecutionModelClose = () => {
        setExecutionConfirmationOpen(false);
        setSaveButtonDisabled(false);
    };

    async function handleClickSave() {
        setExecutionConfirmationOpen(true);
        setSaveButtonDisabled(false);
    }

    const handleCancleDeleteModelClose = () => {
        setDeleteConfirmationOpen(false);
    };

    function handleClickDelete(row) {
        setDeleteConfirmationOpen(true);
        setRowdata(row);
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader onClick={handleClick} />
                </Grid>
            </Grid>
        );
    }


    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title={title}
            >
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: GreenLeafReceivingDetails.groupID,
                            leafTypeID: GreenLeafReceivingDetails.leafTypeID,
                            estateID: GreenLeafReceivingDetails.estateID,
                            factoryID: GreenLeafReceivingDetails.factoryID,
                            leafWeight: GreenLeafReceivingDetails.leafWeight,
                            supplierID: GreenLeafReceivingDetails.supplierID,
                            routeID: GreenLeafReceivingDetails.routeID,
                            collectedDate: collectedDate,
                        }}

                        validationSchema={Yup.object().shape({
                            groupID: Yup.number().required('Group required').min(1, 'Group is required'),
                            estateID: Yup.number().required('Estate is required').min(1, 'Estate is required'),
                            leafTypeID: Yup.number().required('Leaf Type required').min(1, 'Leaf Type is required'),
                            leafWeight: Yup.number().required('Leaf Weight required').min(1, 'Leaf Weight is required'),
                            routeID: Yup.lazy((_, context) =>
                                context.parent.leafTypeID === 3
                                    ? Yup.number().required('Route is required').min(1, 'Route is required')
                                    : Yup.number().notRequired()
                            ),
                            supplierID: Yup.lazy((_, context) =>
                                context.parent.leafTypeID === 3
                                    ? Yup.number().required('Supplier is required').min(1, 'Supplier is required')
                                    : Yup.number().notRequired()
                            ),
                        })}
                        onSubmit={AddData}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(title)}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={2}>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group *
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={GreenLeafReceivingDetails.groupID}
                                                            variant="outlined"
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            disabled={isDropdownDisabled || isUpdate}
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled || isDropdownDisabled
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="estateID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            error={Boolean(touched.estateID && errors.estateID)}
                                                            fullWidth
                                                            helperText={touched.estateID && errors.estateID}
                                                            size='small'
                                                            name="estateID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={GreenLeafReceivingDetails.estateID}
                                                            variant="outlined"
                                                            id="estateID"
                                                            disabled={isDropdownDisabled || isUpdate}
                                                            InputProps={{ readOnly: !permissionList.isFactoryFilterEnabled }}
                                                        >
                                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                                            {generateDropDownMenu(estatesList)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="leafTypeID">
                                                            Leaf Type *
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            error={Boolean(touched.leafTypeID && errors.leafTypeID)}
                                                            fullWidth
                                                            helperText={touched.leafTypeID && errors.leafTypeID}
                                                            name="leafTypeID"
                                                            size='small'
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={GreenLeafReceivingDetails.leafTypeID}
                                                            variant="outlined"
                                                            disabled={isDropdownDisabled || isUpdate}
                                                            InputProps={{
                                                                readOnly: isDropdownDisabled
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Leaf Type--</MenuItem>
                                                            {generateDropDownMenu(leafTypes)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="routeID">
                                                            Route *
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            error={Boolean(touched.routeID && errors.routeID)}
                                                            fullWidth
                                                            helperText={touched.routeID && errors.routeID}
                                                            size='small'
                                                            name="routeID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={GreenLeafReceivingDetails.routeID}
                                                            variant="outlined"
                                                            id="routeID"
                                                            disabled={isUpdate}
                                                        >
                                                            <MenuItem value="0">--Select Route--</MenuItem>
                                                            {generateDropDownMenu(routes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="supplierID">
                                                            Supplier *
                                                        </InputLabel>
                                                        <TextField
                                                            select
                                                            error={Boolean(touched.supplierID && errors.supplierID)}
                                                            fullWidth
                                                            helperText={touched.supplierID && errors.supplierID}
                                                            size='small'
                                                            name="supplierID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={GreenLeafReceivingDetails.supplierID}
                                                            variant="outlined"
                                                            id="supplierID"
                                                            disabled={isUpdate}
                                                        >
                                                            <MenuItem value="0">--Select Supplier--</MenuItem>
                                                            {generateDropDownMenu(suppliers)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="leafWeight">
                                                            Leaf Weight *
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.leafWeight && errors.leafWeight)}
                                                            helperText={touched.leafWeight && errors.leafWeight}
                                                            fullWidth
                                                            name="leafWeight"
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                const { value } = e.target;
                                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                    handleChangeWeight(e);
                                                                }
                                                            }}
                                                            value={GreenLeafReceivingDetails.leafWeight}
                                                            variant="outlined"
                                                            type="number"
                                                            inputProps={{
                                                                step: "0.01",
                                                                min: "0"
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="collectedDate" style={{ marginBottom: '-8px' }}>
                                                            Collected Date *
                                                        </InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                id="collectedDate"
                                                                value={collectedDate}
                                                                maxDate={new Date()}
                                                                onChange={(e) => {
                                                                    setCollectedDate(e);
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                inputProps={{ readOnly: true }}
                                                                disabled={isUpdate}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                </Grid>
                                                <Grid container justify="flex-end" spacing={3}>
                                                    <Box pr={2} style={{ marginTop: '20px' }}>
                                                        <Button
                                                            color="primary"
                                                            variant="outlined"
                                                            type="reset"
                                                            onClick={clearData}
                                                            size='small'
                                                        >
                                                            Clear
                                                        </Button>
                                                    </Box>
                                                    <Box pr={2} style={{ marginTop: '20px' }}>
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            type="submit"
                                                            size='small'
                                                        >
                                                            {isUpdate ? "update" : "Add"}
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                            </CardContent>
                                            {mappingArray.length > 0 && (
                                                <TableContainer component={Paper}>
                                                    <Table size='small'>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Group</TableCell>
                                                                <TableCell>Estate</TableCell>
                                                                <TableCell>Leaf Type</TableCell>
                                                                <TableCell>Route</TableCell>
                                                                <TableCell>Supplier</TableCell>
                                                                <TableCell style={{ textAlign: 'center' }}>Collected Date</TableCell>
                                                                <TableCell style={{ textAlign: 'right' }}>Leaf Weight</TableCell>
                                                                <TableCell>Actions</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {mappingArray.map((row, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell>{row.groupName}</TableCell>
                                                                    <TableCell>{row.estateName}</TableCell>
                                                                    <TableCell>{row.leafTypeName}</TableCell>
                                                                    <TableCell>{row.routeName}</TableCell>
                                                                    <TableCell>{row.supplierName}</TableCell>
                                                                    <TableCell style={{ textAlign: 'center' }}>
                                                                        {new Date(row.collectedDate).toISOString().split('T')[0]}
                                                                    </TableCell>
                                                                    <TableCell style={{ textAlign: 'right' }}> {parseFloat(row.leafWeight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell>
                                                                        <IconButton onClick={() => handleClickDelete(row)}>
                                                                            <Delete color="error" />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                            {(mappingArray.length > 0) ?
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="button"
                                                        variant="contained"
                                                        size='small'
                                                        onClick={handleClickSave}
                                                    >
                                                        {"Save"}
                                                    </Button>
                                                </Box>
                                                : null}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>

                <Dialog open={backConfirmation} onClose={() => setBackConfirmation(false)}>
                    <DialogTitle>
                        <Typography color="textSecondary" variant="h5" align="center">
                            Confirmation
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Typography variant="h6" align="center">
                                Do you want to save the data before going back?
                            </Typography>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>

                        <Button
                            onClick={() => {
                                setBackConfirmation(false);
                                handleSaveAndGoBack();
                            }}
                            color="primary"
                            autoFocus
                        >
                            Yes
                        </Button>
                        <Button
                            onClick={() => {
                                setBackConfirmation(false);
                                handleGoBackWithoutSaving();
                            }}
                            color="primary"
                        >
                            No
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={executionConfirmationOpen} onClose={handleCancleExecutionModelClose}
                    PaperProps={{ style: { borderRadius: "8px", padding: "0.5rem", maxWidth: "400px" } }}
                >
                    <DialogTitle style={{ borderBottom: "1px solid #f0f0f0", padding: "1rem 1.5rem" }}>
                        <Typography variant="h5" style={{ fontWeight: 600, color: "black" }}>
                            Save Confirmation
                        </Typography>
                    </DialogTitle>
                    <DialogContent style={{ padding: "1.5rem" }}>
                        <Typography variant="body1">
                            Are you sure you want to Save Data?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleCancleExecutionModelClose}
                            style={{ color: "#757575", marginRight: "0.5rem", fontWeight: 500, textTransform: "none" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={SaveGreenLeafReceivingData}
                            variant="contained"
                            style={{ backgroundColor: "#3f51b5", color: "white", textTransform: "none", fontWeight: 500, }}
                            disabled={saveButtonDisabled}
                        >
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={deleteConfirmationOpen} onClose={handleCancleDeleteModelClose}
                    PaperProps={{ style: { borderRadius: "8px", padding: "0.5rem", maxWidth: "400px" } }}
                >
                    <DialogTitle style={{ borderBottom: "1px solid #f0f0f0", padding: "1rem 1.5rem" }}>
                        <Typography variant="h5" style={{ fontWeight: 600, color: "black" }}>
                            Delete Confirmation
                        </Typography>
                    </DialogTitle>
                    <DialogContent style={{ padding: "1.5rem" }}>
                        <Typography variant="body1">
                            Are you sure you want to Delete Data?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleCancleDeleteModelClose}
                            style={{ color: "#757575", marginRight: "0.5rem", fontWeight: 500, textTransform: "none" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => DeleteDetails(rowdata)}
                            variant="contained"
                            style={{ backgroundColor: "#f44336", color: "white", textTransform: "none", fontWeight: 500, }}
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </Page >
        </Fragment >
    )
}